import { IonAlert, IonButton, IonLabel, IonModal, IonToast } from "@ionic/react";
import React, { useState } from "react";
import * as constants from "../constants";

export interface AlertMessageProps {
  showAlert: boolean;
  alertMessage: string;
  onDidDismiss: Function;
  alertHeader: string;
  actionItemForAlert: Function;
  cssClass?: string;
  hideActionBtns?: any;
}

export const AlertMessage: React.FC<AlertMessageProps> = ({
  showAlert,
  alertMessage,
  alertHeader,
  onDidDismiss = () => null,
  actionItemForAlert = () => null,
  cssClass = "",
  hideActionBtns = false,
}) => {
  return (
    <>
      <IonModal
        isOpen={showAlert}
        backdropDismiss={true}
        cssClass={!!cssClass ? cssClass + " modalOpacity" : "modalRoot modalOpacity"}
        onDidDismiss={() => onDidDismiss()}
      >
        <div className="changeVehRoot">
          <IonLabel className="changeVehicle">{alertHeader}</IonLabel>
          <IonLabel className="changeVehCon">{alertMessage}</IonLabel>
          {!hideActionBtns ? (
            <div className="confirmButtons">
              <IonButton fill="outline" className="conbtns" onClick={() => onDidDismiss()}>
                <IonLabel className="modalNo">{constants.NO}</IonLabel>
              </IonButton>
              <IonButton
                fill="outline"
                className="conbtns"
                onClick={async () => {
                  actionItemForAlert();
                }}
              >
                <IonLabel className="modalNo">{constants.YES}</IonLabel>
              </IonButton>
            </div>
          ) : (
            <IonButton
              fill="outline"
              className="conbtns"
              style={{ marginTop: 55 }}
              onClick={async () => {
                onDidDismiss();
              }}
            >
              <IonLabel className="modalNo">{constants.OK}</IonLabel>
            </IonButton>
          )}
        </div>
      </IonModal>
    </>
  );
};
